import styled from 'styled-components';

import { Label, Wrapper } from 'src/components/Input/styled';

export const SearchFieldWrapper = styled(Wrapper)<{ $inline?: boolean }>`
  ${({ $inline }) =>
    $inline &&
    `
    margin-bottom: 0;
    width: 100%;
  `}
`;

export { Label };

export const InputShell = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.81rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  background-color: ${({ theme, $disabled }) => ($disabled ? theme.lightGrey : theme.background)};
  transition: all 0.3s ease;

  &:hover:not(:has(input:disabled)) {
    border-color: ${({ theme }) => theme.midGrey};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.primary || '#007bff'};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.lightGrey};
  }

  &:has(input:disabled) {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SearchIcon = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.75rem;
  color: ${({ theme }) => theme.primary};
  line-height: 0;
  pointer-events: none;
`;

export const SearchFieldInput = styled.input<{ $hasIcon?: boolean }>`
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  padding: 0 0.5rem 0 ${({ $hasIcon }) => ($hasIcon ? '0.5rem' : '1rem')};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.dark};
  background: transparent;
  cursor: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.midGrey};
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.midGrey};
  }
`;

export const ClearButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.375rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.125rem;
  line-height: 1;
  color: ${({ theme }) => theme.midGrey};
  background: transparent;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.dark};
    background: ${({ theme }) => theme.lightGrey};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 1px;
  }
`;
